/*global serverPath*/
/*eslint angular/file-name: 0*/
(function() {
    'use strict';
    angular
        .module('emarket.auth', [ 'ui.router', 'satellizer' ])
        .config(['$stateProvider', '$authProvider', 'PATH', function($stateProvider, $authProvider, PATH) {
            $stateProvider
                .state('auth', {
                    url: '/inicio-de-sesion',
                    views: {
                        app: {
                            controller: 'AuthController as auth',
                            templateUrl: 'auth/login/auth.tpl.html'
                        }
                    },
                    resolve: {
                        notAuthenticated: ['$auth', '$q', 'ErrorHandler', function($auth, $q, ErrorHandler) {
                            var promise;
                            if ($auth.isAuthenticated()) {
                                var error = ErrorHandler.create('ALREADY_LOGIN');
                                promise = $q.reject(error);
                            } else {
                                promise = $q.when();
                            }
                            return promise;
                        }]
                    }
                })
                .state('signup', {
                    url: '/registro',
                    views: {
                        app: {
                            controller: 'RegisterController as register',
                            templateUrl: 'auth/registration/signup.tpl.html'
                        }
                    }
                })
                .state('forgot', {
                    url: '/cambiar-clave',
                    views: {
                        app: {
                            controller: 'ForgotController as model',
                            templateUrl: 'auth/forgot/forgot.tpl.html'
                        }
                    }
                })
                .state('forgot-validate', {
                    url: '/cambiar-clave/validar',
                    views: {
                        app: {
                            controller: 'ForgotController as model',
                            templateUrl: 'auth/forgot/change-password.tpl.html'
                        }
                    }
                })
                .state('main.signup-validation', {
                    url: '/registro/validar?token',
                    views: {
                        main: {
                            controller: 'RegisterController as validate',
                            templateUrl: 'auth/registration/user-validation.tpl.html'
                        }
                    },
                    data: {
                        hideBanner: '728x90'
                    }
                })
                .state('signinquestion', {
                    url: '/acceder',
                    views: {
                        app: {
                            templateUrl: 'auth/sign-in-question/sign.in.question.tpl.html',
                            controller: 'SignInQuestionController'
                        }
                    }
                });
            if (serverPath !== 'production') {
                $authProvider.baseUrl = PATH.api;
            } else {
                $authProvider.baseUrl = location.protocol + '//' + location.host + '/api';
            }
            $authProvider.loginUrl = '/auth/email';
            var fbId;
            var gpId;
            if (serverPath === 'production') {
                fbId = '314487945327695';
                gpId = '565072690564-qmigrsb7bf0oam1cjipvheect3jbkb4j.apps.googleusercontent.com';
            } else {
                fbId = '1018576591585490';
                gpId = '565072690564-qmigrsb7bf0oam1cjipvheect3jbkb4j.apps.googleusercontent.com';
            }
            $authProvider.facebook({
                // eMarket - Test1 --- APP Client ID for test or development
                clientId: fbId,
                url: '/auth/facebook'
            });
            $authProvider.google({
                // eMarket - Test1 --- APP Client ID for test or development
                // clientId: 'AIzaSyA1YnnQ4rXtDcw6lHuI00FLavkWS_7mbgI',
                clientId: gpId,
                url: '/auth/google'
            });
            // $authProvider.twitter({
            //     url: '/auth/twitter',
            //     authorizationEndpoint: 'https://api.twitter.com/oauth/authenticate',
            //     redirectUri: window.location.origin,
            //     type: '1.0'
            // });
        }])
        .controller('AuthAccessController', ['$timeout', 'Announcer', 'THEME', function($timeout, Announcer, THEME) {
            var announcer = Announcer.createEmitter();
            $timeout(function() {
                announcer.emit(Announcer.types.CHANGE_THEME_COLOR, THEME.themeColor);
            });
        }]);
}());

/*global serverPath*/
/*eslint angular/file-name: 0*/
(function() {
    'use strict';
    angular
        .module('emarket.auth', [ 'ui.router', 'satellizer' ])
        .config(['$stateProvider', '$authProvider', 'PATH', function($stateProvider, $authProvider, PATH) {
            $stateProvider
                .state('auth', {
                    url: '/inicio-de-sesion',
                    views: {
                        app: {
                            controller: 'AuthController as auth',
                            templateUrl: 'auth/login/auth.tpl.html'
                        }
                    },
                    resolve: {
                        notAuthenticated: ['$auth', '$q', 'ErrorHandler', function($auth, $q, ErrorHandler) {
                            var promise;
                            if ($auth.isAuthenticated()) {
                                var error = ErrorHandler.create('ALREADY_LOGIN');
                                promise = $q.reject(error);
                            } else {
                                promise = $q.when();
                            }
                            return promise;
                        }]
                    }
                })
                .state('signup', {
                    url: '/registro',
                    views: {
                        app: {
                            controller: 'RegisterController as register',
                            templateUrl: 'auth/registration/signup.tpl.html'
                        }
                    }
                })
                .state('forgot', {
                    url: '/cambiar-clave',
                    views: {
                        app: {
                            controller: 'ForgotController as model',
                            templateUrl: 'auth/forgot/forgot.tpl.html'
                        }
                    }
                })
                .state('forgot-validate', {
                    url: '/cambiar-clave/validar',
                    views: {
                        app: {
                            controller: 'ForgotController as model',
                            templateUrl: 'auth/forgot/change-password.tpl.html'
                        }
                    }
                })
                .state('main.signup-validation', {
                    url: '/registro/validar?token',
                    views: {
                        main: {
                            controller: 'RegisterController as validate',
                            templateUrl: 'auth/registration/user-validation.tpl.html'
                        }
                    },
                    data: {
                        hideBanner: '728x90'
                    }
                })
                .state('signinquestion', {
                    url: '/acceder',
                    views: {
                        app: {
                            templateUrl: 'auth/sign-in-question/sign.in.question.tpl.html',
                            controller: 'SignInQuestionController'
                        }
                    }
                });
            if (serverPath !== 'production') {
                $authProvider.baseUrl = PATH.api;
            } else {
                $authProvider.baseUrl = location.protocol + '//' + location.host + '/api';
            }
            $authProvider.loginUrl = '/auth/email';
            var fbId;
            var gpId;
            if (serverPath === 'production') {
                fbId = '314487945327695';
                gpId = '565072690564-qmigrsb7bf0oam1cjipvheect3jbkb4j.apps.googleusercontent.com';
            } else {
                fbId = '1018576591585490';
                gpId = '565072690564-qmigrsb7bf0oam1cjipvheect3jbkb4j.apps.googleusercontent.com';
            }
            $authProvider.facebook({
                // eMarket - Test1 --- APP Client ID for test or development
                clientId: fbId,
                url: '/auth/facebook'
            });
            $authProvider.google({
                // eMarket - Test1 --- APP Client ID for test or development
                // clientId: 'AIzaSyA1YnnQ4rXtDcw6lHuI00FLavkWS_7mbgI',
                clientId: gpId,
                url: '/auth/google'
            });
            // $authProvider.twitter({
            //     url: '/auth/twitter',
            //     authorizationEndpoint: 'https://api.twitter.com/oauth/authenticate',
            //     redirectUri: window.location.origin,
            //     type: '1.0'
            // });
        }])
        .controller('AuthAccessController', ['$timeout', 'Announcer', 'THEME', function($timeout, Announcer, THEME) {
            var announcer = Announcer.createEmitter();
            $timeout(function() {
                announcer.emit(Announcer.types.CHANGE_THEME_COLOR, THEME.themeColor);
            });
        }]);
}());
